import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListaPerfilComponent } from '../lista-perfil/lista-perfil.component';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { GrupoPermissoesService } from '../../api/services/grupo-permissoes.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-home-perfil',
  imports: [
    CommonModule,
    ListaPerfilComponent,
    BackButtonComponent
  ],
  templateUrl: './home-perfil.component.html',
  styleUrl: './home-perfil.component.scss'
})
export class HomePerfilComponent implements OnInit {
  countUsers: number = 0;
  grupoPermissoesService = inject(GrupoPermissoesService);
  messageService = inject(MessageService);

  totalRecords: number = 0;

  ngOnInit(): void {

  }

  onTotalRecordsChange(total: number): void {
    this.totalRecords = total;
  }
}
